import ThemeManager from '../helpers/ThemeManager.js';
import { Component } from '@nicolas-riciotti/light2'

export default class AppSearch extends Component {

    async onFormSubmit() {
        const formData = new FormData(this.$form);
        const params = new URLSearchParams(formData).toString();
        const url = `/?${params}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });
            if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
            const htmlText = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
            const $results = doc.querySelector('#search-results');
            console.log('$SEARCH_RES', $results);
            const $container = this.querySelector('[search-results]');
            if (!$results || !$container) return;
            $container.innerHTML = '';
            $container.insertAdjacentHTML('beforeend', $results.innerHTML);
        } 
        catch (err) {
            console.error('❌ Fetch error:', err);
        }
    }

    attached() {

        this.$input = this.querySelector('input[type="text"]');

        let timer = null
        this.$input.addEventListener('input', e => {
            clearTimeout(timer);
            setTimeout(()=>{
                if (this.$input.value.length >= 3) {
                    this.onFormSubmit();
                }
            }, 1000);
        });

        this.$form = this.querySelector('form');
        this.$form.addEventListener('submit', e => {
            e.preventDefault();
            e.stopPropagation();
            this.onFormSubmit();
        });
    }
}

customElements.define('app-search', AppSearch);